<template>
  <div class="detailBankCard">
    <div :class="AgentIsShow == true ? 'container' : 'settingContainer'">
      <div class="flex-row bankTop">
        <div class="bankWidth"></div>
        <div style="flex: 1; margin: auto">
          <div :class="bankCardStatus.color == 1 ? 'blueBankColor' : 'red'">
            <div class="flex">
              <!-- <div class="whiteBorder">
               <div class="bankImage">
                <img src="../../../../assets/images/gs.png" alt="" />
              </div> 
            </div>-->
              {{ bankMessage.openingBank }}
            </div>

            <div v-if="lookShow" class="flexBetween">
              <div style="word-break: break-all">{{ bankNumber }}</div>
              <van-icon name="eye-o" @click="onClose" />
            </div>
            <div v-else class="flexBetween">
              <div style="word-break: break-all">
                {{ bankMessage.bankNumber }}
              </div>
              <van-icon name="closed-eye" @click="onLook(bankMessage.id)" />
            </div>
          </div>
        </div>
        <div class="bankWidth"></div>
      </div>
      <van-cell title="解绑" is-link @click="onUnbound" />
    </div>
  </div>
</template>
<script>
import {
  Cell,
  CellGroup,
  Form,
  Field,
  Notify,
  Button,
  DatetimePicker,
  Popup,
  Toast,
  Picker,
  Dialog,
  Search,
  Icon,
  ActionSheet,
} from "vant";
import { mapGetters, mapActions } from "vuex";
import service from "../../../api/bank/index";
export default {
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Notify.name]: Notify,
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [Picker.name]: Picker,
    [Dialog.name]: Dialog,
    [Search.name]: Search,
    [Icon.name]: Icon,
    [ActionSheet.name]: ActionSheet,
  },
  data() {
    return {
      bankMessage: {},
      bankNumber: "",
      isColor: 0,
      lookShow: false,
    };
  },
  computed: {
    ...mapGetters(["userInfo", "agentShow", "bankCardStatus"]),
    AgentIsShow() {
      return this.agentShow == null ? false : this.agentShow.isShow;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions(["saveBankStatus"]),
    init() {
      service.get().then((res) => {
        this.isColor = res.data.bankType;
        this.bankMessage = res.data;
      });
      if (this.bankCardStatus !== null && this.bankCardStatus.isShow) {
        service.getReject().then((res) => {
          if (res.statusCode == 200) {
            // 驳回原因在银行详情显示
            Dialog.alert({
              title: "提示",
              message: res.data,
            }).then(() => {
              // on confirm
            });
          }
        });
      }
    },
    onLook(id) {
      service.GetCard(id).then((res) => {
        if (res.statusCode == 200) {
          this.bankNumber = res.data;
          this.lookShow = true;
        }
      });
    },
    onClose() {
      this.lookShow = false;
    },
    onUnbound() {
      Dialog.confirm({
        title: "提示",
        message: "确定解绑么",
      })
        .then(() => {
          // on confirm
          service.put().then((res) => {
            if (res.statusCode == 200 && res.data) {
              Toast("解绑成功");
              // this.statusOut();
              let obj = {
                save: true,
                cardStatus: false,
              };
              this.saveBankStatus(obj);
              // true 显示添加银行卡
              this.$router.go(-1);
            } else {
              Toast(res.errors);
            }
          });
        })
        .catch((err) => {
          Toast("取消解绑");
        });
    },
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";

.detailBankCard {
  // height: calc(100% - 46px);
  overflow: auto;
  display: flex;
  flex-direction: column;
  height: 100%;
  .bankWidth {
    width: 15px;
  }
  .flexBetween {
    width: auto;
    margin-top: 14px;
    // margin-left: 48px;
  }
  .bankName {
    width: 38px;
    height: 38px;
    border-radius: 50%;
    background: #fff;
    margin-right: 14px;
  }
  .bankTop {
    margin-top: 10px;
    margin-bottom: 33px;
    // .flex {
    //   height: 38px;
    // }
  }

  .blueBankColor {
    height: 20.5vw;
    padding: 3.6vw 5.6vw 0;
    color: #fefefe;
    border-radius: 10px;
    background: #2a6add;
  }
  .blue {
    background: #2a6add;
  }
  .red {
    background: #e8414e;
    min-height: 14vw;
    padding: 4.6vw 5.6vw 4.6vw;
    color: #fefefe;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}
</style>
